import { SITE, ACCESSIBILITY_UPDATED } from './siteInfo';
import Fill from './Fill';

// הצהרת נגישות (/accessibility) - לפי תקנה 35 לתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע"ג-2013.
// ההתאמות שמפורטות כאן קיימות בקוד: App.css (מיקוד, דילוג לתוכן, הפחתת תנועה), useModalFocus.js (חלונות),
// SearchBox.jsx (combobox), MainPage.jsx (ניווט, אזורים). התאמה חדשה / מגבלה שתוקנה → לעדכן כאן ואת ACCESSIBILITY_UPDATED.
const AccessibilityStatement = ({ titleStyle, updatedStyle }) => {
  const c = SITE.accessibilityCoordinator;
  return (
    <>
      <h1 style={titleStyle}>הצהרת נגישות</h1>
      <p style={updatedStyle}>עודכן לאחרונה: {ACCESSIBILITY_UPDATED}</p>

      <p>
        אנו ב"{SITE.name}" רואים חשיבות רבה במתן שירות שוויוני לכל המשתמשים, ופועלים כדי שהאתר יהיה נגיש לאנשים עם מוגבלות,
        בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות, התשנ"ח-1998, ולתקנות שהותקנו מכוחו.
      </p>

      <h2>רמת הנגישות</h2>
      <p>
        האתר הותאם לדרישות התקן הישראלי ת"י 5568 (המבוסס על הנחיות WCAG 2.0 של ארגון W3C) ברמה AA, ככל שהדבר אפשרי.
        האתר מותאם לתצוגה בדפדפנים הנפוצים (Chrome, Edge, Firefox, Safari) ולשימוש בטלפון נייד.
      </p>

      <h2>התאמות הנגישות באתר</h2>
      <ul>
        <li>ניווט מלא במקלדת: מעבר בין רכיבים ב-Tab, ומסגרת מיקוד בולטת על הרכיב הפעיל.</li>
        <li>קישור "דילוג לתוכן הראשי" בתחילת כל עמוד.</li>
        <li>חלונות קופצים: המיקוד עובר לחלון כשהוא נפתח, נשאר בתוכו, וחוזר למקומו כשהחלון נסגר; סגירה במקש Escape.</li>
        <li>תמיכה בקוראי מסך: מבנה כותרות, אזורי ניווט ותוכן מסומנים, תוויות לשדות ולכפתורים, והודעות שגיאה ועדכונים מוקראים.</li>
        <li>שדה החיפוש עם הצעות להשלמה: בחירה בחיצים ו-Enter, וההצעה הנבחרת מוקראת.</li>
        <li>ניגודיות צבעים בין טקסט לרקע לפי דרישות התקן, ומידע אינו מועבר בצבע בלבד (למשל "הכי זול" מסומן גם במילים).</li>
        <li>אפשר להגדיל את התצוגה עד 200% (Ctrl ו-+) בלי לאבד תוכן או פעולות.</li>
        <li>כיבוד הגדרת "הפחתת תנועה" של מערכת ההפעלה.</li>
        <li>שפת האתר וכיוון הכתיבה (עברית, מימין לשמאל) מוגדרים, כדי שקוראי מסך יקריאו נכון.</li>
      </ul>

      <h2>מגבלות ידועות</h2>
      <ul>
        <li>
          שמות המוצרים, תמונותיהם ופרטי המבצעים מגיעים מאתרי החנויות כפי שהם. לתמונות המוצרים אין תיאור טקסטואלי נפרד,
          ושם המוצר מוצג לצידן.
        </li>
        <li>אתרי החנויות שאליהם מוביל הכפתור "מעבר למוצר" אינם בשליטתנו, ונגישותם באחריות החנויות.</li>
      </ul>
      <p>אנו ממשיכים לשפר את נגישות האתר. אם נתקלת בבעיה - נשמח לשמוע ולתקן.</p>

      {/* <h2>פנייה בנושא נגישות</h2>
      <p>נתקלת בקושי, או יש לך הצעה לשיפור? פנה/י לרכז/ת הנגישות:</p>
      <ul>
        <li>שם: <Fill value={c.name} /></li>
        <li>טלפון: <Fill value={c.phone} /></li>
        <li>דואר אלקטרוני: <Fill value={c.email} /></li>
      </ul>
      <p>
        כדי שנוכל לטפל בפנייה, נא לפרט את העמוד שבו נתקלת בבעיה, מה ניסית לעשות, ובאיזה דפדפן ו/או טכנולוגיה מסייעת השתמשת.
        נשיב לפנייה בהקדם.
      </p> */}

      <h2>מועד הבדיקה</h2>
      <p>נגישות האתר נבדקה לאחרונה: <Fill value={SITE.accessibilityReviewedAt} /></p>
    </>
  );
};

export default AccessibilityStatement;
